import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import useStrings from "../../localization/useStrings"
import svg from "../../utils/svg"
import styles from "./WinterPaywall.module.scss"
import TopWinter from "../../utils/svg/winter/TopWinter"
import BottomWinter from "../../utils/svg/winter/BottomWinter"
import WaveWinter from "../../utils/svg/winter/WaveWinter"

const winterColors: SeasonalPaywallColors = {
  scrollableGradient: "#CADEFC",
  header: {
    background: "white",
    title: "#6480BD",
    tagline: "#30343D",
  },
  countdown: {
    boxBackground: "#CADDFC",
    value: "#30343D",
    unit: "#313B77",
    label: "#313B77",
  },
  content: {
    background: "#CADEFC",
    ultimateContainerBackground: "#CADEFC",
    ultimateContainerText: "white",
  },
  features: {
    icon: "#6480BD",
    title: "#30343D",
    description: "#65686E",
  },
  footer: {
    background: "#CADEFC",
    primaryButton: {
      background: "#2B5FF5",
      headerBackground: "#2B5FF5",
      contentBackground: "#CADDFC",
      limitedTimeText: "white",
      saveTagText: "white",
      planTitle: "#30343D",
      duration: "#65686E",
      originalPrice: "#65686E",
      discountedPrice: "#30343D",
      monthlyRate: "#30343D",
    },
    monthlyButton: {
      background: "#CADDFC",
      border: "1px solid #E5E5E5",
      label: "#30343D",
      price: "#30343D",
    },
  },
  insets: {
    header: "#CADDFC",
    footer: "#CADDFC",
  },
}

const WinterPaywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      colors={winterColors}
      topDecoration={
        <div className={styles.top}>
          <TopWinter />
        </div>
      }
      headerBackground={
        <div className={styles.headerWave}>
          <WaveWinter />
        </div>
      }
      footerBackground={
        <div className={styles.bottom}>
          <BottomWinter />
        </div>
      }
      strings={{
        title: strings.winterSale.title,
        tagline: strings.winterSale.tagline,
        buttonTitle: "Winter Sale",
      }}
    />
  )
}

export default WinterPaywall
